import React from "react";
import Header from "../Layout/Header";
import Banner from "./Banner";
// import Helping from './Helping';
import Footer from "../Layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config";
import CookieBanner from "./cookieBanner";
import InfiStaking from "./InfiStaking";
import InfiLaunchpad from "./InfiLaunchpad";
import RaisedFund from "./RaisedFund";
import InfiInstitution from "./InfiInstitution";
import InfiHybridEwallet from "./InfiHybridEwallet";
import Tokenization from "./Tokenization";
import Liquidityhub from "./Liquidityhub";
import FutureDecentralised from "./FutureDecentralised";
import Daovotingsystem from "./Daovotingsystem";

export default function Home() {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <Banner />

      {/* <Helping /> */}
      <InfiStaking />
      <div className="bg-darkgrey">
        <Daovotingsystem/>
        <InfiLaunchpad />
        <RaisedFund/>
        <InfiInstitution/>
        <InfiHybridEwallet/>
        <Liquidityhub/>
        <FutureDecentralised/>
        <Tokenization/>
        <Footer />
      </div>
      <CookieBanner />
    </>
  );
}
